import { render, staticRenderFns } from "./ArtikelTambah.vue?vue&type=template&id=2ad52bf6&"
import script from "./ArtikelTambah.vue?vue&type=script&lang=js&"
export * from "./ArtikelTambah.vue?vue&type=script&lang=js&"
import style0 from "./ArtikelTambah.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports